import React from "react";
import styled from "styled-components";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import api from "../api";

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 320px;
`;

export const Thead = styled.thead`
  background-color: #1a5276;
  color: white;
`;
export const Tbody = styled.tbody``;
export const Tr = styled.tr`
  border-bottom: 1px solid #f0f0f0;
  &:last-child { border-bottom: none; }
`;

export const Th = styled.th`
  text-align: start;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 600;
  @media (max-width: 500px) {
    ${(props) => props.onlyWeb && "display: none"}
  }
`;

export const Td = styled.td`
  padding: 10px 12px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  font-size: 14px;
  @media (max-width: 500px) {
    ${(props) => props.onlyWeb && "display: none"}
    padding: 8px 8px;
  }
`;

const SaldoTd = styled.td`
  padding: 10px 12px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => (props.negativo ? "#c0392b" : "#27ae60")};
`;

const GridUsuarios = ({ users, setUsers, setOnEdit }) => {
  const handleEdit = (item) => {
    setOnEdit(item);
  };

  function valorReais(valor) {
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor ?? 0);
  }

  return (
    <TableWrapper>
      <Table>
        <Thead>
          <Tr>
            <Th>Nome</Th>
            <Th onlyWeb>Login</Th>
            <Th onlyWeb>Telefone</Th>
            <Th style={{ textAlign: "center" }}>Saldo</Th>
            <Th style={{ textAlign: "center" }}>[]</Th>
          </Tr>
        </Thead>
        <Tbody>
          {users.map((item, i) => (
            <Tr key={i}>
              <Td>{item.nome}</Td>
              <Td onlyWeb>{item.login}</Td>
              <Td onlyWeb>{item.telefone}</Td>
              <SaldoTd negativo={item.valor < 0}>{valorReais(item.valor)}</SaldoTd>
              <Td alignCenter>
                <FaEdit style={{ cursor: "pointer" }} onClick={() => handleEdit(item)} />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableWrapper>
  );
};

export default GridUsuarios;

